import { inject, Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class FeeDisclaimerService {
  private userService = inject(UserService);

  public needsDisclaimer(prefixCode: string): boolean {
    if (this.userService.isFedUser) return false;
    if (prefixCode === 'CL' || prefixCode === 'CT' || prefixCode === 'CI' || prefixCode === 'CN') {
      return true;
    }
    return false;
  }
}
